import React from 'react';
import PropTypes from 'prop-types';
import Papa from 'papaparse';
import cloudDownload from 'assets/img/icons/cloud-download.svg';
import { Button } from 'react-bootstrap';

const extractChartData = chartData => {
  let extractedData = {};
  if (Array.isArray(chartData)) {
    extractedData.data = chartData;
  } else if (
    typeof chartData === 'object' &&
    chartData?.data &&
    chartData?.series
  ) {
    extractedData.data = Object.values(chartData.data);
  } else {
    return null;
  }
  return extractedData;
};

const ChartDownloadButton = ({ chartData, xAxis, series, filename }) => {
  const currentDate = new Date();
  const timestamp = `${currentDate.getFullYear()}-${String(
    currentDate.getMonth() + 1
  ).padStart(2, '0')}-${String(currentDate.getDate()).padStart(
    2,
    '0'
  )}_${String(currentDate.getHours()).padStart(2, '0')}-${String(
    currentDate.getMinutes()
  ).padStart(2, '0')}-${String(currentDate.getSeconds()).padStart(2, '0')}`;
  const Newfilename = `${filename}_${timestamp}.csv`;

  const transposeData = () => {
    return xAxis.map((month, i) => [month, ...chartData.map(row => row[i])]);
  };

  const handleDownload = () => {
    const transposedData = transposeData();
    const csvData = Papa.unparse({
      fields: ['Month', ...series],
      data: transposedData
    });
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, Newfilename);
    } else {
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute('download', Newfilename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <Button
      variant="light"
      size="sm"
      className="border-300 me-1 text-600"
      onClick={handleDownload}
    >
      <img src={cloudDownload} alt="Download" width={15} />
    </Button>
  );
};

ChartDownloadButton.propTypes = {
  chartData: PropTypes.arrayOf(PropTypes.array).isRequired,
  xAxis: PropTypes.arrayOf(PropTypes.string).isRequired,
  series: PropTypes.arrayOf(PropTypes.string).isRequired,
  filename: PropTypes.string.isRequired
};

export default ChartDownloadButton;
